import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface UpdateUserData {
  email?: User["email"];
  first_name?: User["first_name"];
  last_name?: User["last_name"];
  photo?: User["photo"];
  password?: string;
}

export interface UpdateUserResponse {
  success: boolean;
  message: string;
  user: User;
}

export const useUpdateUser = () => {
  const [data, setData] = useState<UpdateUserResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const updateUser = async (updateData: UpdateUserData) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.patch<UpdateUserResponse>(
        "users/users/update/",
        updateData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      setData(response.data);
      setSuccess(response.data.success);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
        setSuccess(false);
      } else if (err instanceof Error) {
        setError(err.message);
        setSuccess(false);
      } else {
        setError("An unknown error occurred.");
        setSuccess(false);
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, success, updateUser };
};
